<template>
  <div class="d-flex">
    <v-btn small class="h-100 mr-3 btn-box display-lg-none" depressed>
      <v-icon :color="color" small>{{ icon }}</v-icon>
    </v-btn>
    <div class="mr-2">
      <span class="text-caption">{{ title }}</span>
      <h5 class="text_color--text" style="line-height:1">
        {{ text }}
      </h5>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    color: {
      default: "accent",
    },
    title: {
      required: true,
    },
    text: {
      required: true,
    },
    icon: {
      required: true,
    },
  },
};
</script>